<ng-template>
  <div
    (click)="closed.emit()"
    class="tw-flex tw-shrink-0 tw-flex-col tw-rounded tw-border tw-border-solid tw-border-secondary-500 tw-bg-background tw-bg-clip-padding tw-py-2 tw-overflow-y-auto"
    [attr.role]="ariaRole"
    [attr.aria-label]="ariaLabel"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="ariaRole === 'dialog'"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
